import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { MemberStatus, UpdateMemberStatusBody } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `PATCH /v1/users/:id/status` — active ou désactive un membre sans toucher à
 * ses rôles (204). Un membre `DISABLED` ne peut plus se connecter.
 * Réservé au profil `Extranet_Admin`.
 */
export const useUpdateMemberStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: MemberStatus }) =>
      getExtranetApi().patch<UpdateMemberStatusBody, void>(`/v1/users/${encodeURIComponent(id)}/status`, { status }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.members.root() });
    },
  });
};
